import { AnyAri } from '@atlassian/ari';

export type ConfSamplePageLocation = { spaceId: string; pageId: string };

/**
 * Parse TAP trait value containing Confluence space and page ARIs.
 *
 * Expected format: "ari:cloud:confluence:uuid:space/SPACE_ID ari:cloud:confluence:uuid:page/PAGE_ID"
 *
 * @param traitValue - The TAP trait value string containing space and page ARIs
 * @returns Parsed location with spaceId and pageId, or null if parsing fails
 */
export function parseTwcTriggerConfTourTrait(traitValue: string): ConfSamplePageLocation | null {
	if (!traitValue) {
		return null;
	}

	const ariStrings = traitValue.trim().split(/\s+/);
	if (ariStrings.length !== 2) {
		return null;
	}

	const [spaceAriStr, pageAriStr] = ariStrings;

	if (!spaceAriStr || !pageAriStr || !AnyAri.check(spaceAriStr) || !AnyAri.check(pageAriStr)) {
		return null;
	}

	const { resourceId: spaceId } = AnyAri.parse(spaceAriStr);
	const { resourceId: pageId } = AnyAri.parse(pageAriStr);

	return { spaceId, pageId };
}

/**
 * Compare two ConfluencePageLocation objects for equality.
 *
 * @param a - First location to compare
 * @param b - Second location to compare
 * @returns true if both locations have matching spaceId and pageId, false otherwise
 */
export function areLocationsEqual(
	a: ConfSamplePageLocation | null,
	b: ConfSamplePageLocation | null,
): boolean {
	if (!a || !b) {
		return false;
	}

	return a.spaceId === b.spaceId && a.pageId === b.pageId;
}
